import React from "react";
import "./MianBuilderAbout.css";
import MianBuilderAboutLogo from "../../../assets/MB Logo 1.png";

function MianBuilderAbout() {
  return (
    <div className="mian-builder-about-1-custom-container">
      <div className="mian-builder-about-1-custom-content">
        <div className="mian-builder-about-1-custom-text-container">
          <h1 className="mian-builder-about-1-custom-main-title">
            MianBuilder.com
          </h1>
          <p className="mian-builder-about-1-custom-description">
            MianBuilder.com is more than a construction platform; it transmutes
            architectural aspirations into tangible realities.
            <br />
            <br />
            Envision a space where blueprints seamlessly integrate with the
            tangible world, where structures transcend mere physicality to
            embody living visions.
            <br />
            <br />
            Our platform is an evolving canvas where dreams find palpable
            expression. Whether nurturing new beginnings or shaping towering
            accomplishments, each project isn't just a structure; it echoes a
            symphony of trust, a testament to our unwavering dedication to
            materializing aspirations.
          </p>
        </div>
        <a
          href="http://mianbuilder.com"
          target="_blank"
          rel="noopener noreferrer"
          className="mian-builder-about-1-custom-logo-link"
        >
          <div className="mian-builder-about-1-custom-logo-container">
            <img
              src={MianBuilderAboutLogo}
              alt="MianBuilderLogo"
              className="mian-builder-about-1-custom-logo"
            />
          </div>
        </a>
      </div>
    </div>
  );
}

export default MianBuilderAbout;
